// @flow

import moment from "moment"
import type { List, Map } from "immutable"

import type FlightType from "common/records/Flight"
import type JourneyType from "common/records/Journey"

const utcPath = ["when", "utc"]
const localPath = ["when", "local"]
export const utcDeparturePath = ["departure", ...utcPath]
export const utcArrivalPath = ["arrival", ...utcPath]
export const localDeparturePath = ["departure", ...localPath]
export const localArrivalPath = ["arrival", ...localPath]

const convertNegativeDurationToPositiveDuration = (duration: moment) => {
  if (duration >= 0) return duration
  let milliseconds = duration.asMilliseconds()
  milliseconds *= -1 // NOTE convert negative number to positive and vice versa
  return moment.duration(milliseconds)
}

// eslint-disable-next-line flowtype/no-weak-types
export const getFlightDelayDuration = (originalFlight: any, changedFlight: any) => {
  // TODO test!
  if (!changedFlight) {
    return {
      value: moment.duration(0),
    }
  }

  const originalDeparture = originalFlight.getIn(utcDeparturePath)
  const changedDeparture = changedFlight.getIn(utcDeparturePath)

  // departure duration
  let duration = moment.duration(changedDeparture.diff(originalDeparture))

  // if no departure duration check the arrival delay duration
  if (!duration.asMilliseconds()) {
    const originalArrival = originalFlight.getIn(utcArrivalPath)
    const changedArrival = changedFlight.getIn(utcArrivalPath)

    duration = moment.duration(changedArrival.diff(originalArrival))
  }

  return {
    value: convertNegativeDurationToPositiveDuration(duration),
    type: duration.asMilliseconds() < 0 ? "earlier" : "later",
  }
}

export const hasFlightDelay = (duration: moment) => duration && duration.asMinutes() !== 0

export const findFlight = (items: List<Object>, id: string) => items.find(f => f.id === id) // eslint-disable-line flowtype/no-weak-types

export const isNewAlternative = (alternative: JourneyType, id: string) =>
  !alternative.getFlightsIds().includes(id)

export const isMinorDelay = (
  original: FlightType,
  change: Object, // eslint-disable-line flowtype/no-weak-types
) =>
  [getFlightDelayDuration(original, change)]
    .map(d => d.value.asHours())
    .map(h => h !== 0 && h <= 24)[0]

// TODO test
export function addUpdatedTimesToPart(part: FlightType, changes: Map<any, any>) {
  const change = changes.get(part.id)

  if (change) {
    return part
      .setIn(["departure", "when"], change.getIn(["departure", "when"]))
      .setIn(["arrival", "when"], change.getIn(["arrival", "when"]))
  }

  return part
}

export const shouldLoadScheduleChange = (
  scheduleChanges: any,
  retry: number,
  shouldRetry?: boolean,
) =>
  scheduleChanges &&
  !scheduleChanges.get("flightsChecked") &&
  (moment.duration(scheduleChanges.get("validUntil").diff()).asMilliseconds() > 0 || shouldRetry) &&
  retry > 0
